import { useContext, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar/Sidebar";
import AuthMiddleware from "./AuthMiddleware";
import { ThemeContext } from "../common/themeContext";
import { useAdminPermissions } from "../hooks/useAdminPermissions";

const PrivateLayout = () => {
  const { brandId } = useContext(ThemeContext);
  const { refetchProfile } = useAdminPermissions();

  useEffect(() => {
    if (localStorage.getItem("token") && brandId != null) {
      refetchProfile({ refBrandId: brandId });
    }
  }, [brandId, refetchProfile]);

  if (!localStorage.getItem("token")) {
    return <Navigate to="/" replace />;
  }

  return (
    <Sidebar>
      <AuthMiddleware>
        <Outlet />
      </AuthMiddleware>
    </Sidebar>
  );
};

export default PrivateLayout;
